import { Franchise } from "./Franchise";
import { JobZone } from "./JobZone";

export enum EmployeeStatuses {
  ACTIVE = "ACTIVE",
  TERMINATED_REHIRABLE = "TERMINATED_REHIRABLE",
  TERMINATED = "TERMINATED",
}

export enum EmployeeRoles {
  ASSISTANT_MANAGER = "ASSISTANT_MANAGER",
  CLEANING_TECHNICIAN = "CLEANING_TECHNICIAN",
  CLIENT = "CLIENT",
  COO = "COO",
  DOO = "DOO",
  FINANCE = "FINANCE",
  HR_MANAGER = "HR_MANAGER",
  MANAGER = "MANAGER",
  SALES_MANAGER = "SALES_MANAGER",
  SUPERADMIN = "SUPERADMIN",
  SUPERVISOR = "SUPERVISOR",
  SYSTEMUSER = "SYSTEMUSER",
  SALES_REPRESENTATIVE = "SALES_REPRESENTATIVE"
}

export const EmployeeRolesMapping = {
  [EmployeeRoles.ASSISTANT_MANAGER]: 'Assistant Manager',
  [EmployeeRoles.CLEANING_TECHNICIAN]: 'Cleaning Technician',
  [EmployeeRoles.CLIENT]: 'Client',
  [EmployeeRoles.COO]: 'COO',
  [EmployeeRoles.DOO]: 'DOO',
  [EmployeeRoles.FINANCE]: 'Finance Manager',
  [EmployeeRoles.HR_MANAGER]: 'HR Manager',
  [EmployeeRoles.MANAGER]: 'Manager',
  [EmployeeRoles.SALES_MANAGER]: 'Sales Manager',
  [EmployeeRoles.SUPERADMIN]: 'Superadmin',
  [EmployeeRoles.SUPERVISOR]: 'Supervisor',
  [EmployeeRoles.SYSTEMUSER]: 'Systemuser',
  [EmployeeRoles.SALES_REPRESENTATIVE]: 'Sales Representative'
}

export const EmployeeStatusLabels = {
  [EmployeeStatuses.ACTIVE]: "Active",
  [EmployeeStatuses.TERMINATED_REHIRABLE]: "Terminated(Rehirable)",
  [EmployeeStatuses.TERMINATED]: "Terminated",
};

export interface Employee {
  id: string;
  frId: number;
  firstName: string;
  lastName: string;
  email: string;
  accessCode: string;
  employeeLevel: string;
  callInAccess: string;
  hireDate: Date;
  terminationDate: Date;
  mobileAccess: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  ZIP: string;
  homePhone: string;
  workPhone: string;
  emergencyContact: string;
  emergencyContactName: string;
  dlStateN: string;
  ssn: string;
  birthDate: Date;
  payRate: string;
  overTimeRate: number;
  supervisorAlerts: string;
  accountName: string;
  routingNumber: string;
  accountNumber: string;
  notes: string;
  role: string;
  isDeleted: boolean;
  jobZones: JobZone[];
  franchise: Franchise;
  status: EmployeeStatuses;
  desiredHoursPerWeek: number;
  pdfAttachmentsArr: [string];
  otherDocumentsArr: [string];
}

/** Roles that may oversee a job - mirrors JOB_SUPERVISOR_ROLES on the server. */
export const JOB_SUPERVISOR_ROLES: EmployeeRoles[] = [
  EmployeeRoles.SUPERVISOR,
  EmployeeRoles.MANAGER,
  EmployeeRoles.ASSISTANT_MANAGER,
];

/** Roles that may be assigned to a job - mirrors JOB_ASSIGNABLE_ROLES. */
export const JOB_ASSIGNABLE_ROLES: EmployeeRoles[] = [
  EmployeeRoles.CLEANING_TECHNICIAN,
  ...JOB_SUPERVISOR_ROLES,
];
